import { atom } from "jotai";

export const visteAtom = atom<any | null>(null);
